import FactoryFolderIcon from './FactoryFolderIcon'

export default FactoryFolderIcon
